const language = 'french';
export const langDir = 'ltr';

export default language;
